import { render } from "./NavigationView.vue?vue&type=template&id=f15c66c0&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=f15c66c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15c66c0"]])

export default __exports__